var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63294 0.5H6.90051C6.85071 0.5 6.80383 0.524414 6.77454 0.564453L4.00012 4.38867L1.22571 0.564453C1.19641 0.524414 1.14954 0.5 1.09973 0.5H0.367311C0.303835 0.5 0.266725 0.572266 0.303835 0.624024L3.74719 5.37109C3.87219 5.54297 4.12805 5.54297 4.25208 5.37109L7.69544 0.624024C7.73352 0.572266 7.69641 0.5 7.63294 0.5Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/drop-down-arrow.66ca2a8c817e81aa1dee9b30da3a8fbe.svg";
export { ForwardRef as ReactComponent };